{
  "asset_id": "727aa4b5-a822-40b4-bfc1-bc88a9fc2069",
  "content_type": "image/png",
  "created_at": "2026-06-26T14:56:52Z",
  "original_filename": "plan-dhamaka.png",
  "project_id": "1ee18af1-1d84-490c-8b4d-f96ad9f331fc",
  "r2_key": "a/v1/1ee18af1-1d84-490c-8b4d-f96ad9f331fc/727aa4b5-a822-40b4-bfc1-bc88a9fc2069/plan-dhamaka.png",
  "size": 1786961,
  "url": "/__l5e/assets-v1/727aa4b5-a822-40b4-bfc1-bc88a9fc2069/plan-dhamaka.png",
  "version": 1
}